/**
 * @Description 选址地图详情分享页标题内容
 */

import { FC, useMemo, useState } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import cs from 'classnames';
import styles from './top.module.less';
import DataInfoModal from '@/common/components/business/AreaDetailDrawer/components/Top/DataInfoModal';
import LabelRow from 'src/common/components/business/YouthMap/AreaDetailDrawer/components/LabelRow/index';
import ReportLogo from '@/common/components/business/AreaDetailDrawer/components/ReportLogo';
import { isNotEmpty } from '@lhb/func';

interface TopProps {
  detail: any;
  overViewData: any;
  shareParams: any;
}
const Top: FC<TopProps> = ({
  detail,
  overViewData,
  shareParams,
}) => {
  const [openDataInfo, setOpenDataInfo] = useState(false); // 打开数据说明弹窗
  const { isSemirModel } = shareParams || {};
  const showDataDescriptionFlag = useMemo(() => {
    // 1：默认值，2：自定义富文本，3：不展示
    // 如果没有这个参数，也就是没设置过，就沿用老逻辑展示默认值。
    if (!isNotEmpty(detail.showDataDescriptionFlag)) {
      return 1;
    } else {
      return detail.showDataDescriptionFlag;
    }
  }, [detail.showDataDescriptionFlag]);
  return (
    <>
      <div className={styles.topCon}>
        <div className={styles.titleCon}>
          <div className='fs-20 c-222 bold'>
            {detail?.areaName}
          </div>
          {/* 标签行 */}
          <LabelRow
            id={detail?.id}
            detail={detail}
            overViewData={overViewData}
            shareParams={shareParams}
            editable={false}
            style={{ maxWidth: '85%' }}
          />
        </div>
        <div>
          <ReportLogo
            tenantId={shareParams.tenantId}
            tenantLogo={shareParams.reportLogo}
            className='pt-3 mb-16'
          />
          {
            [1, 2].includes(showDataDescriptionFlag) && (
              <div className={styles.targetOffset} onClick={() => {
                setOpenDataInfo(true);
              }}>
                <div className={cs('fs-12 c-666 mt-8 pointer', styles.descCon)}>
                  <span className='pr-4'>数据说明</span>
                  <QuestionCircleOutlined/>
                </div>
              </div>
            )
          }
        </div>
      </div>
      {
        [1, 2].includes(showDataDescriptionFlag) && (
          <DataInfoModal
            open={openDataInfo}
            setOpen={setOpenDataInfo}
            markType={overViewData?.markType}
            shareParams={shareParams}
            isSemirModel={isSemirModel}
            dataDescription={detail.dataDescription}
            showDataDescriptionFlag={showDataDescriptionFlag}
          />
        )
      }
    </>

  );
};

export default Top;
